import { render, staticRenderFns } from "./ErrorGeneralView.vue?vue&type=template&id=4638252f"
import script from "./ErrorGeneralView.vue?vue&type=script&lang=js"
export * from "./ErrorGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports